import { Modal } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../context/User.context"; // Pastikan path ke UserContext benar

// Utility function untuk handle GET, POST, dan PATCH requests
export const useHttp = () => {
  const navigate = useNavigate(); // Menggunakan useNavigate dari React Router
  const { user, setUser } = useContext(UserContext); // Mengambil user dari UserContext

  // Fungsi untuk menampilkan modal error
  const showErrorModal = (errorMessage) => {
    Modal.error({
      title: "Error",
      content: errorMessage || "Something went wrong. Please try again later.",
    });
  };

  // Fungsi untuk menghapus semua data dari localStorage
  const clearLocalStorage = () => {
    localStorage.clear(); // Menghapus semua data dari localStorage
    console.log("All data cleared from localStorage.");
  };

  // Fungsi untuk GET request
  const getData = async (endpoint, config = {}, isAuth = true) => {
    try {
      const headers =
        isAuth && user?.token ? { Authorization: `Bearer ${user.token}` } : {};

      const response = await axios.get(
        `https://cmi-general-platform-be.vercel.app${endpoint}`,
        {
          headers: { ...headers },
          ...config,
        }
      );

      return response.data; // Mengembalikan data dari response
    } catch (error) {
      console.error("GET request failed:", error);

      // Handle 401 Unauthorized error
      if (error?.response?.status === 401) {
        clearLocalStorage(); // Hapus semua data dari localStorage
        navigate("/login"); // Redirect ke halaman login jika token tidak valid
        setUser(null);
        return;
      }

      showErrorModal(error?.response?.data?.message || "Failed to fetch data.");
      throw error; // Melempar error agar dapat ditangani di komponen jika diperlukan
    }
  };

  // Fungsi untuk POST request
  const postData = async (endpoint, data, config = {}, isAuth = true) => {
    try {
      const headers =
        isAuth && user?.token ? { Authorization: `Bearer ${user.token}` } : {};

      const response = await axios.post(
        `https://cmi-general-platform-be.vercel.app${endpoint}`,
        data,
        {
          headers: { ...headers },
          ...config,
        }
      );

      //   showSuccessModal("Data successfully created/updated.");
      return response.data; // Mengembalikan data dari response
    } catch (error) {
      console.error("POST request failed:", error);

      // Handle 401 Unauthorized error
      if (error?.response?.status === 401) {
        clearLocalStorage(); // Hapus semua data dari localStorage
        navigate("/login"); // Redirect ke halaman login jika token tidak valid
        setUser(null);
        return;
      }

      console.log(error);

      showErrorModal(
        error?.response?.data?.error_message || "Failed to create data."
      );
      throw error; // Melempar error agar dapat ditangani di komponen jika diperlukan
    }
  };

  // Fungsi untuk PATCH request
  const patchData = async (endpoint, data, config = {}, isAuth = true) => {
    try {
      const headers =
        isAuth && user?.token ? { Authorization: `Bearer ${user.token}` } : {};

      const response = await axios.patch(
        `https://cmi-general-platform-be.vercel.app${endpoint}`,
        data,
        {
          headers: { ...headers },
          ...config,
        }
      );

      //   showSuccessModal("Data successfully updated.");
      return response.data; // Mengembalikan data dari response
    } catch (error) {
      console.error("PATCH request failed:", error);

      // Handle 401 Unauthorized error
      if (error?.response?.status === 401) {
        clearLocalStorage(); // Hapus semua data dari localStorage
        navigate("/login"); // Redirect ke halaman login jika token tidak valid
        setUser(null);
        return;
      }

      showErrorModal(
        error?.response?.data?.message || "Failed to update data."
      );
      throw error; // Melempar error agar dapat ditangani di komponen jika diperlukan
    }
  };

  return { getData, postData, patchData };
};
